import type { HostedParty, HostPartyStats } from "./types";

/**
 * A backend without the photographers release (PR #261) answers the host
 * endpoints without the new fields. Fill them with what an old event is: a
 * guests-only event whose caller is its creator-organizer (an old server only
 * answers the creator). Only absent fields are filled; a new server's values
 * are kept as sent.
 */
const base = {
  whoShoots: "guests",
  organizerPreview: true,
  guestDownloads: true,
  proPublishedAt: null,
  keepUntilOverride: null,
  myRole: "organizer",
  isLead: false,
} as const;

function fill<T extends object>(row: T, defaults: Record<string, unknown>): T {
  const out = { ...row } as Record<string, unknown>;
  for (const [k, v] of Object.entries(defaults)) if (out[k] === undefined) out[k] = v;
  return out as T;
}

export function normaliseHostStats(p: HostPartyStats): HostPartyStats {
  return fill(p, { ...base, isCreator: true, pro: { total: 0, published: 0, pending: 0 } });
}

export function normaliseHostedParty(p: HostedParty): HostedParty {
  return fill(p, base);
}
